import { Grid, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import {
  IconAccessPoint,
  IconRouter,
  IconUsers,
  IconVideoMinus,
  IconWifi,
} from "@tabler/icons";
import React from "react";
import { useTranslation } from "react-i18next";

const FiltersStationsComponent = (props) => {
  const {
    checked,
    onClickFilter = () => { },
  } = props
  const { t } = useTranslation()
  const theme = useTheme();

  return (
    <Grid
      container
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%" }}
    >
      <Grid item xs={12} mb={0.5} display="flex"
        justifyContent="center">
        <Typography align="center" variant='caption'>{t('Filter by component type')}</Typography>
      </Grid>

      <Grid item ml={1} mr={1}>
        <Tooltip title={t('environmental monitoring')}>
          <IconButton
            onClick={() => onClickFilter("ENVSENSOR")}
            sx={{
              color: checked && checked["ENVSENSOR"]
                ? "white"
                : theme.palette.mode === "dark"
                  ? "#84d0d1"
                  : theme.palette.primary.main,
              backgroundColor: checked && checked["ENVSENSOR"]
                ? theme.palette.primary.main
                : theme.palette.mode === "dark"
                  ? "#07354f"
                  : "#afcbcc80",
              borderRadius: 2,
              border:
                theme.palette.mode === "dark"
                  ? `1px solid #0f5c87`
                  : `1px solid #afcbcc`,
              padding: 0.6,
              "&.MuiIconButton-root:hover": {
                backgroundColor: checked && checked["ENVSENSOR"]
                  ? theme.palette.primary.main
                  : "transparent",
                border: `1px solid ${theme.palette.primary.main}`,
              },
            }}
          >
            <IconRouter style={{ width: 20, height: 20 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item ml={1} mr={1}>
        <Tooltip title={t('people-counter')}>
          <IconButton
            onClick={() => onClickFilter("PCOUNTER")}
            sx={{
              color: checked && checked["PCOUNTER"]
                ? "white"
                : theme.palette.mode === "dark"
                  ? "#84d0d1"
                  : theme.palette.primary.main,
              backgroundColor: checked && checked["PCOUNTER"]
                ? theme.palette.primary.main
                : theme.palette.mode === "dark"
                  ? "#07354f"
                  : "#afcbcc80",
              borderRadius: 2,
              border:
                theme.palette.mode === "dark"
                  ? `1px solid #0f5c87`
                  : `1px solid #afcbcc`,
              padding: 0.5,
              "&.MuiIconButton-root:hover": {
                backgroundColor: checked && checked["PCOUNTER"]
                  ? theme.palette.primary.main
                  : "transparent",
                border: `1px solid ${theme.palette.primary.main}`,
              },
            }}
          >
            <IconUsers style={{ width: 21, height: 21 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item ml={1} mr={1}>
        <Tooltip title="Camera">
          <IconButton
            onClick={() => onClickFilter("CAMERA")}
            sx={{
              color: checked && checked["CAMERA"]
                ? "white"
                : theme.palette.mode === "dark"
                  ? "#84d0d1"
                  : theme.palette.primary.main,
              backgroundColor: checked && checked["CAMERA"]
                ? theme.palette.primary.main
                : theme.palette.mode === "dark"
                  ? "#07354f"
                  : "#afcbcc80",
              borderRadius: 2,
              padding: 0.5,
              border:
                theme.palette.mode === "dark"
                  ? `1px solid #0f5c87`
                  : `1px solid #afcbcc`,
              "&.MuiIconButton-root:hover": {
                backgroundColor: checked && checked["CAMERA"]
                  ? theme.palette.primary.main
                  : "transparent",
                border: `1px solid ${theme.palette.primary.main}`,
              },
            }}
          >
            <IconVideoMinus style={{ width: 21, height: 21 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item ml={1} mr={1}>
        <Tooltip title="WiFi">
          <IconButton
            onClick={() => onClickFilter("WIFI")}
            sx={{
              color: checked && checked["WIFI"]
                ? "white"
                : theme.palette.mode === "dark"
                  ? "#84d0d1"
                  : theme.palette.primary.main,
              backgroundColor: checked && checked["WIFI"]
                ? theme.palette.primary.main
                : theme.palette.mode === "dark"
                  ? "#07354f"
                  : "#afcbcc80",
              borderRadius: 2,
              padding: 0.5,
              border:
                theme.palette.mode === "dark"
                  ? `1px solid #0f5c87`
                  : `1px solid #afcbcc`,
              "&.MuiIconButton-root:hover": {
                backgroundColor: checked && checked["WIFI"]
                  ? theme.palette.primary.main
                  : "transparent",
                border: `1px solid ${theme.palette.primary.main}`,
              },
            }}
          >
            <IconWifi style={{ width: 21, height: 21 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item ml={1} mr={1}>
        <Tooltip title="Gateway">
          <IconButton
            onClick={() => onClickFilter("GATEWAY")}
            sx={{
              color: checked && checked["GATEWAY"]
                ? "white"
                : theme.palette.mode === "dark"
                  ? "#84d0d1"
                  : theme.palette.primary.main,
              backgroundColor: checked && checked["GATEWAY"]
                ? theme.palette.primary.main
                : theme.palette.mode === "dark"
                  ? "#07354f"
                  : "#afcbcc80",
              borderRadius: 2,
              border:
                theme.palette.mode === "dark"
                  ? `1px solid #0f5c87`
                  : `1px solid #afcbcc`,
              padding: 0.5,
              "&.MuiIconButton-root:hover": {
                backgroundColor: checked && checked["GATEWAY"]
                  ? theme.palette.primary.main
                  : "transparent",
                border: `1px solid ${theme.palette.primary.main}`,
              },
            }}
          >
            <IconAccessPoint style={{ width: 21, height: 21 }} />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default FiltersStationsComponent;
